/*
import {
  hf,
  ht,
  cr,
  a,
  l,
//  usePagez,
//  BarC,
  BoxC,
  BtnC,
  GridC,
  IptC,
  LblC,
  LinkC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as LinkC from "./_cccLinkC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';

import * as spl from './sample';

export const N = (pz: {
}) => {

  const _ls = [] as ht.ls;

  _ls.push({
    cells: [
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'stfTblHdrz',
            textz: {
              pfx: '',
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'stfTblHdrz',
            textz: {
              pfx: '午前',
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'stfTblHdrz',
            textz: {
              pfx: '午後①',
            }
          }),
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'stfTblHdrz',
            textz: {
              pfx: '午後②',
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'stfTblHdrz',
            textz: {
              pfx: '夜間',
            }
          })
        ]
      }
    ]
  });

  spl.rooms.filter( (_dz: ht.dz) => _dz.pfx != '料理' ).map( ( _dz:ht.dz, _nIdx: ht.n) => {

    _ls.push({
      cells: [
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'stfTblBdyz',
              textz: {
                pfx: _dz.pfx,
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(LinkC.N, {
              key: -10,
              abtType: 'stfTblBdyz',
              cz: {
                url: 'https://www.google.com',
              },
              linkCz: {
                abtType: 'cmnLinkz',
                textz: {
                  pfx: '団体〇〇〇〇〇〇',
                  stlz: a('tb tc/yw5 tu'),
                }
              }
            }),
            cr.c(TextC.N, {
              key: -20,
              abtType: 'stfTblEnnz',
              textz: {
                pfx: '内容 ■□■□■□■□■',
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(LinkC.N, {
              key: -10,
              abtType: 'stfTblBdyz',
              cz: {
                url: 'https://www.google.com',
              },
              linkCz: {
                abtType: 'cmnLinkz',
                textz: {
                  pfx: '団体〇〇〇〇〇〇',
                  stlz: a('tb tc/yw5 tu'),
                }
              }
            }),
            cr.c(TextC.N, {
              key: -10,
              abtType: 'stfTblEnnz',
              textz: {
                pfx: '内容 ■□■□■□■□■',
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(LinkC.N, {
              key: -10,
              abtType: 'stfTblBdyz',
              cz: {
                url: 'https://www.google.com',
              },
              linkCz: {
                abtType: 'cmnLinkz',
                textz: {
                  pfx: '団体〇〇〇〇〇〇',
                  stlz: a('tb tc/yw5 tu'),
                }
              }
            }),
            cr.c(TextC.N, {
              key: -10,
              abtType: 'stfTblEnnz',
              textz: {
                pfx: '内容 ■□■□■□■□■',
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(LinkC.N, {
              key: -10,
              abtType: 'stfTblBdyz',
              cz: {
                url: 'https://www.google.com',
              },
              linkCz: {
                abtType: 'cmnLinkz',
                textz: {
                  pfx: '団体〇〇〇〇〇〇',
                  stlz: a('tb tc/yw5 tu'),
                }
              }
            }),
            cr.c(TextC.N, {
              key: -10,
              abtType: 'stfTblEnnz',
              textz: {
                pfx: '内容 ■□■□■□■□■',
              }
            })
          ]
        },
      ]
    });

  });

  const _ls2 = [];

  _ls2.push({
    cells: [
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'stfTblHdrz',
            textz: {
              pfx: '',
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'stfTblHdrz',
            textz: {
              pfx: '午前①',
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'stfTblHdrz',
            textz: {
              pfx: '午前②',
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'stfTblHdrz',
            textz: {
              pfx: '午後①',
            }
          }),
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'stfTblHdrz',
            textz: {
              pfx: '午後②',
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'stfTblHdrz',
            textz: {
              pfx: '午後③',
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'stfTblHdrz',
            textz: {
              pfx: '夜間',
            }
          })
        ]
      }
    ]
  });

  spl.rooms.filter( (_dz: ht.dz) => _dz.pfx == '料理' ).map( ( _dz:ht.dz, _nIdx: ht.n) => {

    _ls2.push({
      cells: [
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'stfTblBdyz',
              textz: {
                pfx: _dz.pfx,
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(LinkC.N, {
              key: -10,
              abtType: 'stfTblBdyz',
              cz: {
                url: 'https://www.google.com',
              },
              linkCz: {
                abtType: 'cmnLinkz',
                textz: {
                  pfx: '団体〇〇〇〇〇〇',
                }
              }
            }),
            cr.c(TextC.N, {
              key: -10,
              abtType: 'stfTblEnnz',
              textz: {
                pfx: '内容 ■□■□■□■□■',
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(LinkC.N, {
              key: -10,
              abtType: 'stfTblBdyz',
              cz: {
                url: 'https://www.google.com',
              },
              linkCz: {
                abtType: 'cmnLinkz',
                textz: {
                  pfx: '団体〇〇〇〇〇〇',
                  stlz: a('tb tc/yw5 tu'),
                }
              }
            }),
            cr.c(TextC.N, {
              key: -10,
              abtType: 'stfTblEnnz',
              textz: {
                pfx: '内容 ■□■□■□■□■',
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(LinkC.N, {
              key: -10,
              abtType: 'stfTblBdyz',
              cz: {
                url: 'https://www.google.com',
              },
              linkCz: {
                abtType: 'cmnLinkz',
                textz: {
                  pfx: '団体〇〇〇〇〇〇',
                  stlz: a('tb tc/yw5 tu'),
                }
              }
            }),
            cr.c(TextC.N, {
              key: -10,
              abtType: 'stfTblEnnz',
              textz: {
                pfx: '内容 ■□■□■□■□■',
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(LinkC.N, {
              key: -10,
              abtType: 'stfTblBdyz',
              cz: {
                url: 'https://www.google.com',
              },
              linkCz: {
                abtType: 'cmnLinkz',
                textz: {
                  pfx: '団体〇〇〇〇〇〇',
                  stlz: a('tb tc/yw5 tu'),
                }
              }
            }),
            cr.c(TextC.N, {
              key: -10,
              abtType: 'stfTblEnnz',
              textz: {
                pfx: '内容 ■□■□■□■□■',
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(LinkC.N, {
              key: -10,
              abtType: 'stfTblBdyz',
              cz: {
                url: 'https://www.google.com',
              },
              linkCz: {
                abtType: 'cmnLinkz',
                textz: {
                  pfx: '団体〇〇〇〇〇〇',
                  stlz: a('tb tc/yw5 tu'),
                }
              }
            }),
            cr.c(TextC.N, {
              key: -10,
              abtType: 'stfTblEnnz',
              textz: {
                pfx: '内容 ■□■□■□■□■',
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(LinkC.N, {
              key: -10,
              abtType: 'stfTblBdyz',
              cz: {
                url: 'https://www.google.com',
              },
              linkCz: {
                abtType: 'cmnLinkz',
                textz: {
                  pfx: '団体〇〇〇〇〇〇',
                  stlz: a('tb tc/yw5 tu'),
                }
              }
            }),
            cr.c(TextC.N, {
              key: -10,
              abtType: 'stfTblEnnz',
              textz: {
                pfx: '内容 ■□■□■□■□■',
              }
            })
          ]
        },
      ]
    });

  });

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

/*
        cr.c(BarC.N, {
          key: -10,
          abtType: 'ftnStfz',
        }),
*/
        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

            cr.c(BoxC.N, {
              key: -20,
              boxStlz: a('dw/f dwx/40 f/1 fd/ccc mh/a'),
              oClds: [

                cr.c(LblC.N, {
                  key: -10,
                  abtType: 'vclStfz',
                  boxStlz: a('mb/4'),
                  lblCz: {
                    textz: {
                      pfx: '対象月',
                    }
                  },
                  cttCz: {
                    oClds: [
                      cr.c(IptC.S, {
                        cz: {
                          bEdit: true,
                          iptType: 'text',
                          vle: '2022-10',
                          ls: [
                            { key: 1, pfx: '2022-10' },
                            { key: 2, pfx: '2022-11' },
                            { key: 3, pfx: '2022-12' },
                          ],
                        }
                      })
                    ],
                  }
                }),

                cr.c(BtnC.N, {
                  key: -20,
                  boxStlz: a('br/1 dw/36 fd/ccc sc/gn7 pv/0.5'),
                  lblCz: {
                    textz: {
                      pfx: '実績集計表を出力',
                      stlz: a('tb tc/lt1'),
                    }
                  },
                })

              ]
            }),

          ]
        })

      ]
    })
  );
};
